import React, { useState, useEffect } from 'react';
import axios from 'axios'; 
import { format } from 'date-fns';

const Production = ({ caseId }) => {
  const [caseData, setCaseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!caseId) return; // agar caseId na mile to fetch mat karo

    const fetchData = async () => {
      try {
        
        const response = await axios.get(
          `https://hms.backend.hiragroupcloud.com/api/cases/cases/${caseId}`
        );
        
        setCaseData(response.data);
      } catch (err) {
        console.error('Error fetching case data:', err);
        setError('Error fetching case data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [caseId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  // Dates ko format karna
  const creationDate = caseData?.createdAt
    ? format(new Date(caseData.createdAt), 'dd MMM yyyy HH:mm:ss')
    : 'N/A';
  const lastUpdatedDate = caseData?.updatedAt
    ? format(new Date(caseData.updatedAt), 'dd MMM yyyy HH:mm:ss')
    : 'N/A';
  const sendToLabDate = caseData?.date
    ? format(new Date(caseData.date), 'dd MMM yyyy')
    : 'N/A';

  return (
    <div style={{ fontSize: '24px' }}>
      <h2>Production</h2>

      <div>
        <p style={{ fontWeight: 'bold', fontSize: '16px' }}>Creation Date:</p>
        <h6>{creationDate}</h6>
      </div>

      <div>
        <p style={{ fontWeight: 'bold', fontSize: '16px' }}>Last Updated:</p>
        <h6>{lastUpdatedDate}</h6>
      </div>

      <div>
        <p style={{ fontWeight: 'bold', fontSize: '16px' }}>Send to Lab Date:</p>
        <h6>{sendToLabDate}</h6>
      </div>

      {/* <div>
        <p style={{ fontWeight: 'bold', fontSize: '16px' }}>Case ID:</p>
        <h6>{caseData?.case_id || 'N/A'}</h6>
      </div> */}
    </div>
  );
};

export default Production;
